// extracted by mini-css-extract-plugin
export default {"root":"SortSelect_root__2jZkK","sort-item":"SortSelect_sort-item__8Akg9"};